'use client'

import { useSession } from 'session/src/hooks/useSession'
import useSWRImmutable from 'swr/immutable'
import type { User } from 'types/session/user'

import {
	userDetailsService,
	userDetailsUrl,
} from '../services/userDetailsService'

export function useUserDetails(
	shouldFetch = true,
	shouldRefresh = false
): User | null {
	const { logged, token, externalId } = useSession()

	const shouldFetchData = shouldFetch && logged && token && externalId
	const { data } = useSWRImmutable(
		shouldFetchData ? userDetailsUrl : null,
		() => userDetailsService(token, externalId, shouldRefresh),
		{ suspense: true }
	)

	return data
}
